// utils/socialUtils.js

import insta from '../../src/InsocialOrbit/Assets/Img/insta deliverables.svg';  // Import the Instagram image
import youtube from '../../src/InsocialOrbit/Assets/Img/youtube deliverables.svg';  // Import the Instagram image

export const getSocialPlatforms = async (platform, handle) => {
    const defaultImageUrl = '/default-profile-pic.png'; // Fallback image

    let profileImageUrl = defaultImageUrl;

    try {
        switch (platform.toLowerCase()) {
            case 'instagram':
                // Instead of fetching from the API, we will use the imported image for Instagram
                return insta; // Instagram profile image
                break;
            case 'youtube':
                // Use Facebook Graph API for the profile picture
                return youtube;
                break;
            case 'twitter':
                // Twitter profile picture URL
                profileImageUrl = `https://twitter.com/${handle}/profile_image?size=original`;
                break;
            case 'snapchat':
                // Snapchat doesn't have an API for profile pictures, fallback image
                profileImageUrl = '/snapchat-placeholder.png';
                break;
            default:
                // Fallback for unknown platforms
                profileImageUrl = '/generic-placeholder.png';
        }
    } catch (error) {
        console.error(`Error fetching profile image for ${platform}:`, error);
        profileImageUrl = defaultImageUrl;
    }

    return profileImageUrl;
};
